module.exports = __webpack_public_path__ + "assets/img/ventajas-rakumart-23.d53e4439.png";